// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3L9UC","colMin":"styles_colMin__uIiDF","colCheckbox":"styles_colCheckbox__mTUE3"};